import { _ } from '@ngx-translate/core';

/**
 * Stream Chat Angular SDK default English translations.
 * Copied from the SDK's internal `en` object.
 * Values wrapped in _() for Phrase gettext extraction.
 * Keys must match the SDK exactly — do not fix typos in keys.
 */
export const STREAM_CHAT_TRANSLATIONS = {
  streamChat: {
    '1 reply': _('1 reply'),
    'Attach files': _('Attach files'),
    Cancel: _('Cancel'),
    'Channel Missing': _('Channel Missing'),
    Close: _('Close'),
    'Close emoji picker': _('Close emoji picker'),
    'Commands matching': _('Commands matching'),
    'Connection failure, reconnecting now...': _('Connection failure, reconnecting now...'),
    Delete: _('Delete'),
    Delivered: _('Delivered'),
    'Edit Message': _('Edit Message'),
    'Edit message request failed': _('Edit message request failed'),
    'Emoji matching': _('Emoji matching'),
    'Empty message...': _('Empty message...'),
    'Error adding flag': _('Error adding flag'),
    'Error connecting to chat, refresh the page to try again.': _(
      'Error connecting to chat, refresh the page to try again.',
    ),
    'Error deleting message': _('Error deleting message'),
    'Error loading reactions': _('Error loading reactions'),
    'Error muting a user ...': _('Error muting a user ...'),
    'Error pinning message': _('Error pinning message'),
    'Error removing message pin': _('Error removing message pin'),
    'Error unmuting a user ...': _('Error unmuting a user ...'),
    'Error uploading file': _('Error uploading file'),
    'Error uploading file, maximum file size exceeded': _('Error uploading file, maximum file size exceeded'),
    'Error uploading file, extension not supported': _('Error uploading file, extension not supported'),
    'Error deleting attachment': _('Error deleting attachment'),
    'Error \u00B7 Unsent': _("Message couldn't be sent"),
    'Error: {{ errorMessage }}': _('Error: {{ errorMessage }}'),
    Flag: _('Flag'),
    'Message Failed': _('Message Failed'),
    'Message Failed \u00B7 Unauthorized': _('Unauthorized to send message'),
    'Message Failed \u00B7 Click to try again': _("Message couldn't be sent, click to try again"),
    'Message deleted': _('Message deleted'),
    'Message has been successfully flagged': _('Message has been successfully flagged'),
    'Message pinned': _('Message pinned'),
    'Message unpinned': _('Message unpinned'),
    Mute: _('Mute'),
    New: _('New'),
    'New Messages!': _('New Messages!'),
    'No results found': _('No results found'),
    'Nothing yet...': _('Nothing yet...'),
    'Only visible to you': _('Only visible to you'),
    'Open emoji picker': _('Open emoji picker'),
    'People matching': _('People matching'),
    'Pick your emoji': _('Pick your emoji'),
    Pin: _('Pin'),
    'Pinned by': _('Pinned by'),
    Reply: _('Quote Reply'),
    'Reply to Message': _('Reply to Message'),
    Search: _('Search'),
    'Searching...': _('Searching...'),
    Send: _('Send'),
    'Send message request failed': _('Send message request failed'),
    'Sending...': _('Sending...'),
    'Slow Mode ON': _('Slow Mode ON'),
    'Start of a new thread': _('Start of a new thread'),
    'This message was deleted...': _('This message was deleted...'),
    Thread: _('Thread'),
    'Type your message': _('Type your message'),
    Unmute: _('Unmute'),
    Unpin: _('Unpin'),
    'Wait until all attachments have uploaded': _('Wait until all attachments have uploaded'),
    'You have no channels currently': _('You have no channels currently'),
    "You've reached the maximum number of files": _("You've reached the maximum number of files"),
    live: _('live'),
    'this content could not be displayed': _('this content could not be displayed'),
    '{{ commaSeparatedUsers }} and {{ moreCount }} more': _('{{ commaSeparatedUsers }} and {{ moreCount }} more'),
    '{{ commaSeparatedUsers }}, and {{ lastUser }}': _('{{ commaSeparatedUsers }}, and {{ lastUser }}'),
    '{{ firstUser }} and {{ secondUser }}': _('{{ firstUser }} and {{ secondUser }}'),
    '{{ imageCount }} more': _('{{ imageCount }} more'),
    '{{ memberCount }} members': _('{{ memberCount }} members'),
    '{{ replyCount }} replies': _('{{ replyCount }} replies'),
    '{{ user }} has been muted': _('{{ user }} has been muted'),
    '{{ user }} has been unmuted': _('{{ user }} has been unmuted'),
    '{{ watcherCount }} online': _('{{ watcherCount }} online'),
    '\uD83C\uDFD9 Attachment...': _('\uD83C\uDFD9 Attachment...'),
    'Connection error': _('Connection error'),
    'Load more': _('Load more'),
    failed: _('failed'),
    retry: _('retry'),
    'Sending links is not allowed in this conversation': _('Sending links is not allowed in this conversation'),
    "You can't send messages in this channel": _("You can't send messages in this channel"),
    "You can't send thread replies in this channel": _("You can't send thread replies in this channel"),
    'Message not found': _('Message not found'),
    'No chats here yet\u2026': _('No chats here yet\u2026'),
    'user is typing': _('{{ user }} is typing'),
    'users are typing': _('{{ users }} are typing'),
    'Error loading channels': _('Error loading channels'),
    'See original (automatically translated)': _('See original (automatically translated)'),
    'See translation': _('See translation'),
    'Mark as unread': _('Mark as unread'),
    'Error marking message as unread': _('Error marking message as unread'),
    'Error, only the first {{count}} message can be marked as unread': _(
      'Error, only the first {{count}} message can be marked as unread',
    ),
    'Unread messages': _('Unread messages'),
    '{{count}} unread messages': _('{{count}} unread messages'),
    '{{count}} unread message': _('{{count}} unread message'),
    'This message did not meet our content guidelines': _('This message did not meet our content guidelines'),
    'Send Anyway': _('Send Anyway'),
    Edited: _('Edited'),
    'Error playing audio': _('Error playing audio'),
    'Copy text': _('Copy text'),
    'Please grant permission to use microhpone': _('Please grant permission to use microhpone'),
    'Error starting recording': _('Error starting recording'),
    'An error has occurred during recording': _('An error has occurred during recording'),
    'Media recording not supported': _('Media recording not supported'),
    "You can't uplod more than {{max}} attachments": _("You can't uplod more than {{max}} attachments"),
    'You currently have {{count}} attachments, the maximum is {{max}}': _(
      'You currently have {{count}} attachments, the maximum is {{max}}',
    ),
    'and others': _('and others'),
    'Message was blocked by moderation policies': _('Message was blocked by moderation policies'),
    'Vote ended': _('Vote ended'),
    'Select one': _('Select one'),
    'Select up to {{count}}': _('Select up to {{count}}'),
    'Select one or more': _('Select one or more'),
    'See all options ({{count}})': _('See all options ({{count}})'),
    'Suggest an option': _('Suggest an option'),
    'Add a comment': _('Add a comment'),
    'Update your comment': _('Update your comment'),
    'View {{ count }} comments': _('View {{ count }} comments'),
    'View {{ count }} comment': _('View {{ count }} comment'),
    'View results': _('View results'),
    'End vote': _('End vote'),
    'After a poll is closed, no more votes can be cast': _('After a poll is closed, no more votes can be cast'),
    'Failed to end vote': _('Failed to end vote'),
    'Failed to cast vote': _('Failed to cast vote'),
    Anonymous: _('Anonymous'),
    '{{ count }} votes': _('{{ count }} votes'),
    'Show all': _('Show all'),
    'Poll results': _('Poll results'),
    'Error loading votes': _('Error loading votes'),
    'Poll comments': _('Poll comments'),
    'Error loading answers': _('Error loading answers'),
    Comment: _('Comment'),
    'Failed to add comment': _('Failed to add comment'),
    'Failed to add option ({{ message }})': _('Failed to add option ({{ message }})'),
    'Option already exists': _('Option already exists'),
    'You have reached the maximum number of votes allowed': _('You have reached the maximum number of votes allowed'),
    'Create poll': _('Create poll'),
    Create: _('Create'),
    Question: _('Question'),
    'Ask a question': _('Ask a question'),
    'Question is required': _('Question is required'),
    Options: _('Options'),
    'Add an option': _('Add an option'),
    'Multiple answers': _('Multiple answers'),
    'Maximum number of votes': _('Maximum number of votes'),
    'Provide a value between {{ min }} and {{ max }}': _('Provide a value between {{ min }} and {{ max }}'),
    'Anonymous poll': _('Anonymous poll'),
    'Allow option suggestions': _('Allow option suggestions'),
    'Allow comments': _('Allow comments'),
    'Failed to create poll': _('Failed to create poll'),
    'Provide at least one option': _('Provide at least one option'),
    'Poll options': _('Poll options'),
  },
};
